import { connect } from 'react-redux'
import EducationSpan from './EducationSpan'

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const EducationSpanContainer = connect(
    mapStateToProps,
)(EducationSpan)

export default EducationSpanContainer
